<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户合同'}]"/>
    <el-row class="xzpadd10 bg-purple">
        <data-table
          :tableData="contractListData"
          :columns="contractListColumns"
          :filters="filters"
          :pageSize.sync="pageSize"
          :page.sync="page"
          class="xzmLR10"
        ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ServerAdminContractList',
    data() {
      return {
        filterOptions: {
        },
        page: 1,
        pageSize: 10,
        contractListData: {},
        filters: {
          form: {
            ct__contractNo: '',
            u__customerName: '',
            ct__productName: '',
            ct__createdDate: [],
            ct__contractStatus: ''
          },
          columns: [
            {
              label: '合同编号',
              component: 'el-input',
              field: 'ct__contractNo'
            },
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '贷款产品',
              component: 'el-input',
              field: 'ct__productName'
            },
            {
              label: '创建日期',
              component: 'date-range-picker',
              field: 'ct__createdDate'
            },
            {
              label: '合同状态',
              component: 'el-select',
              field: 'ct__contractStatus',
              options: [
                {
                  label: '已生效',
                  value: 'Active'
                },
                {
                  label: '未生效',
                  value: 'UnActive'
                },
                {
                  label: '已失效',
                  value: 'Expired'
                }
              ]
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerContractList()
          }
        }
      }
    },
    computed : {
      contractListColumns: function() {
        return [
          {
            name: '合同编号',
            field: 'ct__contractNo'
          },
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          // {
          //   name: '申请日期',
          //   field: 'ct__applicationDate',
          //   formatter: function (r,c,v) {
          //     return moment(v).format('YYYY-MM-DD')
          //   }
          // },
          // {
          //   name: '供应链',
          //   field: 'ct__debtorName'
          // },
          {
            name: '贷款产品',
            field: 'ct__productName',
          },
          {
            name: '合同起始日',
            field: 'ct__contractValidity1',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '合同到期日',
            field: 'ct__contractValidity2',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '利率',
            field: 'ct__interestRate',
            formatter:function (r,c,v) {
              return v+'% ('+ Status2CN(r.ct__interestType) +')'
            }
          },
          {
            name: '服务费',
            field: 'ct__lendingFee',
            formatter: function (r,c,v) {
              return formatMoney(v)+ (r.ct__lendingFeeType == 'Rate' ? '%' : ' 元')
            }
          },
          {
            name: '合同状态',
            field: 'ct__contractStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '操作',
            opts: [
              {
                clickHandler: (index, row)=>{
                  this.viewDetail(index, row)
                },
                class: 'el-icon-info',
                name: '查看'
              },
            ]

          }
        ]
      },
      filterParams: {
        get: function () {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'ct.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerContractList()
      }
    },
    mounted() {
      this.getCustomerContractList()
    },
    methods: {
      getCustomerContractList: function () {
        xhr.getCustomerContractList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.contractListData = res.data
          }catch(e){

          }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'Detail?ct.contractId='+ row.ct__contractId})
        }
        catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ContractList.vue